import apiClient, { extractData, handleApiError } from './api.js';

export class TableSessionService {
  /**
   * Create a table session (Public - customer request)
   * POST /api/v1/table-sessions
   */
  static async createSession({ outletSlug, tableNumber, customerName }) {
    try {
      const response = await apiClient.post('/table-sessions', {
        outlet_slug: outletSlug,
        table_number: tableNumber,
        customer_name: customerName,
      });
      return extractData(response);
    } catch (error) {
      console.error('Error creating table session:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Get session status (Public - customer polling)
   * GET /api/v1/table-sessions/{sessionId}/status
   */
  static async getSessionStatus(sessionId) {
    try {
      const response = await apiClient.get(`/table-sessions/${sessionId}/status`);
      return extractData(response);
    } catch (error) {
      console.error('Error fetching session status:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Approve a session
   * PATCH /api/v1/table-sessions/{sessionId}/approve
   */
  static async approveSession(sessionId) {
    try {
      const response = await apiClient.patch(`/table-sessions/${sessionId}/approve`);
      return extractData(response);
    } catch (error) {
      console.error('Error approving session:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Reject a session
   * PATCH /api/v1/table-sessions/{sessionId}/reject
   */
  static async rejectSession(sessionId) {
    try {
      const response = await apiClient.patch(`/table-sessions/${sessionId}/reject`);
      return extractData(response);
    } catch (error) {
      console.error('Error rejecting session:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Complete a session
   * PATCH /api/v1/table-sessions/{sessionId}/complete
   */
  static async completeSession(sessionId) {
    try {
      const response = await apiClient.patch(`/table-sessions/${sessionId}/complete`);
      return extractData(response);
    } catch (error) {
      console.error('Error completing session:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Get pending sessions (for staff/owner notification polling)
   * GET /api/v1/table-sessions/pending?outlet_id=...
   */
  static async getPendingSessions(outletId) {
    try {
      const response = await apiClient.get('/table-sessions/pending', {
        params: { outlet_id: outletId },
      });
      return extractData(response);
    } catch (error) {
      console.error('Error fetching pending sessions:', error);
      throw new Error(handleApiError(error));
    }
  }
}
